import { UserContext } from "../../Models/User/UserContext";

const defaultState: UserContext = {
  userGUID: "",
  email: "",
};

export default defaultState;
